/* eslint-disable eqeqeq */
import React, { useEffect, useState, useRef } from "react";
import TokenModal from "./TokenDialog";
import { PendingLabel } from "./Spinner";
import { safeParseUnits, toUnitString } from "../utility/amount";
import { NETWORK_LABEL } from "../contexts/config";
import SlippageSettings from "./SlippageSettings";
import { useConnectWallet } from "../hooks/useConnectWallet";
import { IoSettings } from "react-icons/io5";
import { useParams, useNavigate } from "react-router-dom";
import {
    getErc20Contract,
    getFactoryContract,
    getRouterContract,
    getWalletBalanceContract,
} from "../contexts/thirdWebClient";
import { allowance, balanceOf } from "thirdweb/extensions/erc20";
import { routerAddress, WETHAddress } from "../contexts/config";
import {
    useActiveAccount,
    useActiveWalletChain,
} from "thirdweb/react";
import { prepareContractCall, readContract, sendTransaction as sendTx } from "thirdweb";
import { toast } from "react-toastify";
import { ethers } from "ethers";
import { getCurrencyMetadata } from "thirdweb/extensions/erc20";

const AddLiquidity = () => {
    const [open, setOpen] = useState(false);
    const [openBuy, setOpenBuy] = useState(false);
    const [selected, setSelected] = useState({});
    const [selectedBuy, setSelectedBuy] = useState({});
    const [loading, setLoading] = useState(false);
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [checkData, setCheckData] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [slippage, setSlippage] = useState(() => {
        const saved = localStorage.getItem("usdx_slippage");
        return saved ? parseFloat(saved) : 1;
    });

    const add = useActiveAccount();
    const [address, setAddress] = useState("");
    const chain = useActiveWalletChain();
    const { openConnect, isConnecting } = useConnectWallet();
    useEffect(() => {
        if (add && add.address) {
            setAddress(add.address);
        } else {
            // Disconnecting has to clear this, or the card keeps showing the
            // approve/deposit buttons for an account that is no longer there.
            setAddress("");
        }
    }, [add, chain]);
    let navigate = useNavigate();
    const { address1, address2 } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            if (address1) {
                const tokenData = await tokenDetails(address1);
                setSelected(tokenData);
            }
            if (address2) {
                const tokenData = await tokenDetails(address2);
                setSelectedBuy(tokenData);
            }
            setCheckData(true);
        };
        fetchData();
    }, [address1, address2, add, chain]); // eslint-disable-line react-hooks/exhaustive-deps

    const [token1Details, setToken1Details] = useState({});
    const [token2Details, setToken2Details] = useState({});

    const [token1value, setToken1value] = useState(0);
    const [token2value, setToken2value] = useState(0);

    const [price, setPrice] = useState(1);

    const isValidAddress = (addr) => /^0x[a-fA-F0-9]{40}$/.test(addr);

    const tokenDetails = async (value) => {
        try {
            if (value && isValidAddress(value) && chain && chain?.id) {
                const contract = getErc20Contract(value, chain);
                let currencyMetadata = await getCurrencyMetadata({ contract });
                currencyMetadata.address = value;
                return currencyMetadata;
            } else {
                return false;
            }
        } catch (error) {
            console.log("%c Line:85 🍎 tokenDetails error", "color:#6ec1c2", error);
            return false;
        }
    };

    useEffect(() => {
        if (checkData) {
            let route = `/pool/addliquidity/`;
            if (selected && selected !== "" && selected.address !== address1) {
                route += selected.address + "/";
            } else {
                route += address1 + "/";
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy.address !== address2
            ) {
                route += selectedBuy.address;
            } else {
                route += address2;
            }
            navigate(route);
        }
    }, [selected, selectedBuy]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const getData = async () => {
            setBalanceLoading(true);
            if (
                selected &&
                selected !== "" &&
                selected?.address &&
                address &&
                selected?.address !=
                    "0x0000000000000000000000000000000000000000"
            ) {
                const contract = getErc20Contract(selected.address, chain);
                let approvedAmount = await allowance({
                    contract,
                    owner: address,
                    spender: routerAddress,
                });
                let tokenBalance = await balanceOf({
                    contract,
                    address: address,
                });
                setToken1Details({
                    ...selected,
                    approvedBalance: Number(approvedAmount) * 1,
                    balance: Number(ethers.formatUnits(tokenBalance, selected?.decimals)) * 1,
                });
            }
            if (
                selected &&
                selected !== "" &&
                selected?.address ==
                    "0x0000000000000000000000000000000000000000"
            ) {
                let tokenBalance = await getWalletBalanceContract(
                    address,
                    chain,
                );
                setToken1Details({
                    ...selected,
                    approvedBalance: Number(100000000000) * 1,
                    balance: Number(ethers.formatUnits(tokenBalance, 18)) * 1,
                });
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy?.address &&
                selectedBuy?.address !=
                    "0x0000000000000000000000000000000000000000" &&
                address
            ) {
                const contract = getErc20Contract(selectedBuy.address, chain);
                let approvedAmount = await allowance({
                    contract,
                    owner: address,
                    spender: routerAddress,
                });
                let tokenBalance = await balanceOf({
                    contract,
                    address: address,
                });
                setToken2Details({
                    ...selectedBuy,
                    approvedBalance: Number(approvedAmount) * 1,
                    balance: Number(ethers.formatUnits(tokenBalance, selectedBuy?.decimals)) * 1,
                });
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy?.address ==
                    "0x0000000000000000000000000000000000000000"
            ) {
                let tokenBalance = await getWalletBalanceContract(
                    address,
                    chain,
                );
                setToken2Details({
                    ...selectedBuy,
                    approvedBalance: Number(100000000000) * 1,
                    balance: Number(ethers.formatUnits(tokenBalance, 18)) * 1,
                });
            }
            setBalanceLoading(false);
        };
        getData();
    }, [selected, selectedBuy, loading]); // eslint-disable-line react-hooks/exhaustive-deps

    // Guards every wallet-facing action against re-entry. A ref rather than
    // `loading`, because state does not update until React re-renders — a fast
    // second click would otherwise open a second wallet request.
    const inFlight = useRef(false);

    const approveTokenFun = async (tokenAddress) => {
        if (inFlight.current) return;
        inFlight.current = true;
        try {
            setLoading(true);
            const contract = getErc20Contract(tokenAddress, chain);
            const transaction = prepareContractCall({
                contract,
                method: "function approve(address guy, uint256 wad) returns (bool)",
                params: [routerAddress, ethers.MaxUint256],
            });
            console.log(
                "%c Line:117 🍢 transaction",
                "color:#ed9ec7",
                transaction,
                add,
            );
            const tx = await sendTx({ transaction, account: add });
            console.log("%c Line:118 🥔 tx", "color:#93c0a4", tx);
            toast.success("Token approved");
        } catch (error) {
            toast.error(error?.message);
            console.log("%c Line:111 🍫 error", "color:#ed9ec7", error);
        } finally {
            inFlight.current = false;
            setLoading(false);
        }
    };



    // Calculate minimum amount with slippage
    const calculateMinAmount = (amount, decimals) => {
        try {
            const slippageMultiplier = (100 - slippage) / 100;
            const minAmount = parseFloat(amount) * slippageMultiplier;
            return safeParseUnits(minAmount, decimals);
        } catch (error) {
            console.log("Error calculating min amount:", error);
            return "1"; // Fallback
        }
    };

    const addLiquidity = async () => {
        if (inFlight.current) return;
        inFlight.current = true;
        try {
            setLoading(true);
            const contract = getRouterContract(chain);

            let token1amount = safeParseUnits(
                token1value,
                token1Details?.decimals,
            );

            let token2amount = safeParseUnits(
                token2value,
                token2Details?.decimals,
            );

            let transaction;
            if (
                token1Details?.address ==
                    "0x0000000000000000000000000000000000000000" ||
                token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
            ) {
                transaction = prepareContractCall({
                    contract,
                    method: "function addLiquidityETH(address token, uint256 amountTokenDesired, uint256 amountTokenMin, uint256 amountETHMin, address to, uint256 deadline) payable returns (uint256 amountToken, uint256 amountETH, uint256 liquidity)",
                    params: [
                        token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                            ? token2Details?.address
                            : token1Details?.address,
                        token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                            ? token2amount
                            : token1amount,
                        calculateMinAmount(token1Details?.address == "0x0000000000000000000000000000000000000000" ? token2value : token1value, token1Details?.address == "0x0000000000000000000000000000000000000000" ? token2Details?.decimals : token1Details?.decimals),
                        calculateMinAmount(token1Details?.address == "0x0000000000000000000000000000000000000000" ? token1value : token2value, token1Details?.address == "0x0000000000000000000000000000000000000000" ? token1Details?.decimals : token2Details?.decimals),
                        address,
                        Math.floor(new Date().getTime() / 1000) + 900,
                    ],
                    value:
                        token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                            ? token1amount
                            : token2amount,
                });
            } else {
                transaction = prepareContractCall({
                    contract,
                    method: `function addLiquidity(address tokenA, address tokenB, uint256 amountADesired,uint256 amountBDesired,uint256 amountAMin,uint256 amountBMin,address to,uint256 deadline)`,
                    params: [
                        token1Details?.address,
                        token2Details?.address,
                        token1amount,
                        token2amount,
                        calculateMinAmount(token1value, token1Details?.decimals),
                        calculateMinAmount(token2value, token2Details?.decimals),
                        address,
                        Math.floor(new Date().getTime() / 1000) + 900,
                    ],
                });
            }
            const txData = await sendTx({ transaction, account: add });
            console.log("%c Line:173 🥐 txData", "color:#3f7cff", txData);
            toast.success("Liquidity Added");

            // Reset input values after successful liquidity addition
            setToken1value(0);
            setToken2value(0);

            // Redirect to pool page with refresh state
            navigate('/pool', { state: { refresh: true } });
        } catch (error) {
            toast.error(error?.message);
            console.log("%c Line:166 🍕 error", "color:#f5ce50", error);
        } finally {
            inFlight.current = false;
            setLoading(false);
        }
    };

    useEffect(() => {
        if (token1Details.address && token2Details.address) {
            fetchLpDetails();
        }
    });

    const [lpAddress, setLpAddress] = useState(false);
    const [token1LpBalance, setToken1LpBalance] = useState(0);
    const [token2LpBalance, setToken2LpBalance] = useState(0);

    const fetchLpDetails = async () => {
        try {
            const routerContract = await getRouterContract(chain);
            const factoryContract = await getFactoryContract(chain);

            let pairAddress = await readContract({
                contract: factoryContract,
                method: "function getPair(address, address) view returns (address)",
                params: [
                    token1Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                ],
            });

            if(pairAddress != "0x0000000000000000000000000000000000000000"){
                setLpAddress(true);
                console.log(
                    "%c Line:224 🍧 pairAddress",
                    "color:#7f2b82",
                    pairAddress,
                );
    
                const Token0contract = getErc20Contract(
                    token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    chain,
                );
                let tokenOUserBalance = await balanceOf({
                    contract: Token0contract,
                    address: pairAddress,
                });
                setToken1LpBalance(tokenOUserBalance);
    
                const Token1contract = getErc20Contract(
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                    chain,
                );
    
                let token1UserBalance = await balanceOf({
                    contract: Token1contract,
                    address: pairAddress,
                });
                setToken2LpBalance(token1UserBalance);
    
                let tokenPrice = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits("1", selected?.decimals),
                        tokenOUserBalance,
                        token1UserBalance,
                    ],
                });
    
                setPrice(
                    Number(
                        ethers.formatUnits(tokenPrice, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            }else {
                setPrice(0)
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPriceDetails = async (value) => {
        try {
            // Clear token2 value if input is empty or invalid
            if (!value || value === '' || parseFloat(value) <= 0) {
                setToken2value(0);
                return;
            }

            if(lpAddress && token1LpBalance > 0 && token2LpBalance > 0){
                const routerContract = await getRouterContract(chain);

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        safeParseUnits(value, selected?.decimals),
                        token1LpBalance,
                        token2LpBalance,
                    ],
                });

                setToken2value(
                    Number(
                        ethers.formatUnits(token0Price, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPrice2Details = async (value) => {
        try {
            // Clear token1 value if input is empty or invalid
            if (!value || value === '' || parseFloat(value) <= 0) {
                setToken1value(0);
                return;
            }

            if(lpAddress && token1LpBalance > 0 && token2LpBalance > 0){
                const routerContract = await getRouterContract(chain);

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        safeParseUnits(value, selectedBuy?.decimals),
                        token2LpBalance,
                        token1LpBalance,
                    ],
                });
                setToken1value(
                    Number(
                        ethers.formatUnits(token0Price, selected?.decimals),
                    ).toFixed(5),
                );
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const bothSelected = Boolean(token1Details?.symbol && token2Details?.symbol);
    const isNewPool = bothSelected && !lpAddress;

    /* Row in the position-details panel. Falls back to an em dash so the panel
       holds its shape before a pair is chosen. */
    const Detail = ({ label, value, accent }) => (
        <div className="flex items-baseline justify-between gap-3 py-2.5 border-b border-usdx-line-soft last:border-b-0">
            <span className="text-[12px] text-usdx-ink-subtle font-medium shrink-0">{label}</span>
            <span
                className={`num text-[12px] font-semibold text-right truncate ${
                    accent ? "text-usdx-accent" : "text-usdx-ink"
                }`}
            >
                {value ?? "—"}
            </span>
        </div>
    );

    return (
        <div className="w-full max-w-[1000px] grid grid-cols-1 lg:grid-cols-[minmax(0,470px)_minmax(0,1fr)] gap-4 lg:gap-5 items-start justify-center">
            <div className="w-full flex flex-col card-3d p-4 sm:p-6">
                {/* Header — back to the positions list, title, slippage */}
                <div className="flex items-center justify-between gap-2 mb-5">
                    <button
                        type="button"
                        onClick={() => navigate("/pool")}
                        aria-label="Back to positions"
                        className="swap-arrow-3d w-9 h-9 flex items-center justify-center shrink-0"
                    >
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <h2 className="text-[18px] xs:text-[20px] sm:text-[22px] font-bold gradient-text text-center">
                        Add Liquidity
                    </h2>
                    <button
                        type="button"
                        className="swap-arrow-3d w-9 h-9 flex items-center justify-center shrink-0"
                        onClick={() => setSettingsOpen(true)}
                        aria-label="Slippage settings"
                        title="Slippage settings"
                    >
                        <IoSettings className="size-[18px]" />
                    </button>
                </div>

                {/* First token */}
                <div className="inner-3d p-4">
                    <div className="flex justify-between items-center gap-2 mb-3">
                        <span className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest">
                            First token
                        </span>
                        {address && token1Details?.symbol && (
                            <div className="flex items-center gap-2 shrink-0">
                                <span className="text-[12px] text-usdx-ink-subtle">
                                    Balance{" "}
                                    <span className="num text-usdx-ink font-semibold">
                                        {balanceLoading
                                            ? "…"
                                            : token1Details?.balance
                                            ? token1Details.balance.toFixed(4)
                                            : "0.0000"}
                                    </span>
                                </span>
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (!token1Details?.balance) return;
                                        // Clamp to the token's precision — a raw
                                        // float would put more decimals in the
                                        // field than the token can represent.
                                        const max = toUnitString(
                                            token1Details.balance,
                                            token1Details?.decimals,
                                        );
                                        setToken1value(max);
                                        fetchPriceDetails(max);
                                    }}
                                    className="text-[11px] font-bold text-usdx-accent uppercase tracking-wider hover:text-usdx-accent-dark transition-colors"
                                >
                                    Max
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="flex items-center justify-between gap-3">
                        <input
                            className="num text-[26px] xs:text-[28px] sm:text-[32px] font-bold text-usdx-ink bg-transparent outline-none w-full min-w-0 placeholder:text-usdx-ink-subtle/40"
                            type="number"
                            min="0"
                            step="any"
                            value={token1value === 0 || token1value === '' ? '' : token1value}
                            placeholder="0.0"
                            aria-label="Amount of the first token to deposit"
                            onChange={(e) => {
                                setToken1value(e.target.value);
                                fetchPriceDetails(e.target.value);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                    e.preventDefault();
                                }
                            }}
                        />
                        <button
                            type="button"
                            onClick={() => setOpen(!open)}
                            className="token-pill-3d flex items-center gap-2 px-3 py-2.5 shrink-0 select-none"
                        >
                            {selected?.symbol ? (
                                <>
                                    {selected?.img && (
                                        <img src={selected.img} alt="" className="size-[24px] rounded-full ring-1 ring-usdx-line" />
                                    )}
                                    <span className="font-bold text-[15px] text-usdx-ink whitespace-nowrap">{selected.symbol}</span>
                                </>
                            ) : (
                                <span className="font-semibold text-[13px] text-usdx-accent whitespace-nowrap">Select token</span>
                            )}
                            <svg className="w-3.5 h-3.5 text-usdx-ink-subtle" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" /></svg>
                        </button>
                    </div>
                </div>

                {/* Pairing indicator — same convert glyph as the swap form, so the
                    two token fields read as one paired deposit. Kept inside the
                    gap between the panels, not overlapping them. */}
                <div className="flex justify-center py-2">
                    <div className="swap-arrow-3d w-11 h-11 flex items-center justify-center" aria-hidden="true">
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                        </svg>
                    </div>
                </div>

                {/* Second token */}
                <div className="inner-3d p-4">
                    <div className="flex justify-between items-center gap-2 mb-3">
                        <span className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest">
                            Second token
                        </span>
                        {address && token2Details?.symbol && (
                            <div className="flex items-center gap-2 shrink-0">
                                <span className="text-[12px] text-usdx-ink-subtle">
                                    Balance{" "}
                                    <span className="num text-usdx-ink font-semibold">
                                        {balanceLoading
                                            ? "…"
                                            : token2Details?.balance
                                            ? token2Details.balance.toFixed(4)
                                            : "0.0000"}
                                    </span>
                                </span>
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (!token2Details?.balance) return;
                                        // Clamp to the token's precision — a raw
                                        // float would put more decimals in the
                                        // field than the token can represent.
                                        const max = toUnitString(
                                            token2Details.balance,
                                            token2Details?.decimals,
                                        );
                                        setToken2value(max);
                                        fetchPrice2Details(max);
                                    }}
                                    className="text-[11px] font-bold text-usdx-accent uppercase tracking-wider hover:text-usdx-accent-dark transition-colors"
                                >
                                    Max
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="flex items-center justify-between gap-3">
                        <input
                            className="num text-[26px] xs:text-[28px] sm:text-[32px] font-bold text-usdx-ink bg-transparent outline-none w-full min-w-0 placeholder:text-usdx-ink-subtle/40"
                            type="number"
                            min="0"
                            step="any"
                            value={token2value === 0 || token2value === '' ? '' : token2value}
                            placeholder="0.0"
                            aria-label="Amount of the second token to deposit"
                            onChange={(e) => {
                                setToken2value(e.target.value);
                                fetchPrice2Details(e.target.value);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                    e.preventDefault();
                                }
                            }}
                        />
                        <button
                            type="button"
                            onClick={() => setOpenBuy(!openBuy)}
                            className="token-pill-3d flex items-center gap-2 px-3 py-2.5 shrink-0 select-none"
                        >
                            {selectedBuy?.symbol ? (
                                <>
                                    {selectedBuy?.img && (
                                        <img src={selectedBuy.img} alt="" className="size-[24px] rounded-full ring-1 ring-usdx-line" />
                                    )}
                                    <span className="font-bold text-[15px] text-usdx-ink whitespace-nowrap">{selectedBuy.symbol}</span>
                                </>
                            ) : (
                                <span className="font-semibold text-[13px] text-usdx-accent whitespace-nowrap">Select token</span>
                            )}
                            <svg className="w-3.5 h-3.5 text-usdx-ink-subtle" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" /></svg>
                        </button>
                    </div>
                </div>

                {/* No wallet yet: the approve/deposit buttons below cannot exist
                    (both depend on an allowance), so the card would otherwise
                    end with no action at all. */}
                {!address && (
                    <button
                        className="mt-4 w-full py-4 text-[16px] font-bold btn-3d"
                        disabled={isConnecting}
                        onClick={openConnect}
                    >
                        {isConnecting ? (
                            <PendingLabel>Connecting…</PendingLabel>
                        ) : (
                            "Connect wallet"
                        )}
                    </button>
                )}

                {/* Approvals, then the deposit itself. A brand-new pair needs
                    one allowance per token before the router can move them. */}
                {address && token1Details?.symbol && token1Details?.approvedBalance <= 0 && (
                    <button
                        className="mt-3 w-full py-4 text-[16px] font-bold btn-3d"
                        disabled={loading}
                        onClick={() => !loading && approveTokenFun(token1Details?.address)}
                    >
                        {loading ? (
                            <PendingLabel>Approving…</PendingLabel>
                        ) : (
                            `Approve ${token1Details?.symbol}`
                        )}
                    </button>
                )}
                {address && token2Details?.symbol && token2Details?.approvedBalance <= 0 && (
                    <button
                        className="mt-3 w-full py-4 text-[16px] font-bold btn-3d"
                        disabled={loading}
                        onClick={() => !loading && approveTokenFun(token2Details?.address)}
                    >
                        {loading ? (
                            <PendingLabel>Approving…</PendingLabel>
                        ) : (
                            `Approve ${token2Details?.symbol}`
                        )}
                    </button>
                )}
                {address && token1Details?.approvedBalance > 0 && token2Details?.approvedBalance > 0 && (
                    <button
                        className="mt-4 w-full py-4 text-[16px] font-bold btn-3d"
                        /* The balance checks belong here too: without them the
                           button stayed pressable while reading "Insufficient
                           … balance", and the deposit reverted on-chain. */
                        disabled={
                            loading ||
                            !selected?.symbol ||
                            !selectedBuy?.symbol ||
                            !token1value ||
                            !token2value ||
                            token1value <= 0 ||
                            token2value <= 0 ||
                            parseFloat(token1value) > token1Details?.balance ||
                            parseFloat(token2value) > token2Details?.balance
                        }
                        onClick={addLiquidity}
                    >
                        {loading ? (
                            <PendingLabel>Adding liquidity…</PendingLabel>
                        ) : (
                            <>{!selected?.symbol || !selectedBuy?.symbol
                            ? "Select both tokens"
                            : !token1value || !token2value || token1value <= 0 || token2value <= 0
                            ? "Enter an amount"
                            : parseFloat(token1value) > token1Details?.balance
                            ? `Insufficient ${token1Details?.symbol} balance`
                            : parseFloat(token2value) > token2Details?.balance
                            ? `Insufficient ${token2Details?.symbol} balance`
                            : isNewPool
                            ? "Create pool & deposit"
                            : "Add liquidity"}</>
                        )}
                    </button>
                )}

                <TokenModal open={open} setOpen={setOpen} onClick={setSelected} />
                <TokenModal open={openBuy} setOpen={setOpenBuy} onClick={setSelectedBuy} />
                <SlippageSettings open={settingsOpen} setOpen={setSettingsOpen} slippage={slippage} setSlippage={setSlippage} />
            </div>

            {/* ── Position details ───────────────────────────────────────── */}
            <aside className="w-full flex flex-col gap-4">
                <div className="card-3d p-4 sm:p-5">
                    <h3 className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest mb-1">
                        Position details
                    </h3>
                    <div className="flex flex-col">
                        <Detail
                            label="Pool"
                            value={bothSelected ? (isNewPool ? "New pool" : "Existing pool") : null}
                            accent={isNewPool}
                        />
                        <Detail
                            label="Rate"
                            value={
                                lpAddress && bothSelected
                                    ? `1 ${token1Details.symbol} = ${price} ${token2Details.symbol}`
                                    : null
                            }
                        />
                        <Detail
                            label="Depositing"
                            value={
                                bothSelected && token1value > 0 && token2value > 0
                                    ? `${token1value} ${token1Details.symbol} + ${token2value} ${token2Details.symbol}`
                                    : null
                            }
                        />
                        <Detail label="Slippage tolerance" value={`${slippage}%`} accent />
                        <Detail label="Network" value={NETWORK_LABEL} />
                    </div>
                </div>

                {/* First deposit sets the price for a brand-new pool */}
                {isNewPool && (
                    <div className="card-3d p-4 sm:p-5">
                        <p className="text-[12px] font-bold text-usdx-warning mb-1.5">
                            You are creating this pool
                        </p>
                        <p className="text-[12px] text-usdx-ink-subtle leading-relaxed">
                            No pool exists for this pair yet, so the ratio you deposit sets
                            its starting price. Match the true market rate or you will be
                            arbitraged on the first trades.
                        </p>
                    </div>
                )}

                {address && bothSelected && (
                    <div className="card-3d p-4 sm:p-5">
                        <h3 className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest mb-3">
                            Your balances
                        </h3>
                        <div className="flex flex-col gap-2">
                            {[token1Details, token2Details].map((t, i) => (
                                <div key={i} className="pool-card-3d flex items-center justify-between gap-3 px-3 py-2.5">
                                    <span className="text-[13px] font-bold text-usdx-ink truncate">
                                        {t?.symbol}
                                    </span>
                                    <span className="num text-[13px] font-medium text-usdx-ink-muted shrink-0">
                                        {balanceLoading ? "…" : t?.balance ? t.balance.toFixed(4) : "0.0000"}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {!bothSelected && (
                    <div className="card-3d p-4 sm:p-5">
                        <p className="text-[12px] text-usdx-ink-subtle leading-relaxed">
                            Choose both sides of the pair to see the current rate, whether a
                            pool already exists, and what you will be depositing.
                        </p>
                    </div>
                )}
            </aside>

            {/* ── How it works + things to know ──────────────────────────── */}
            <section className="lg:col-span-2 w-full card-3d p-4 sm:p-6">
                <h3 className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest mb-4 text-left">
                    How it works
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {[
                        {
                            step: "1",
                            title: "Choose the pair",
                            desc: "Pick both tokens. If no pool exists yet, your deposit creates it and sets the opening price.",
                        },
                        {
                            step: "2",
                            title: "Approve each token",
                            desc: "The router needs a one-off allowance per token before it can move them — two approvals on a brand-new pair.",
                        },
                        {
                            step: "3",
                            title: "Deposit and earn",
                            desc: "You receive LP tokens for your share of the pool, and start earning a cut of the 0.30% fee on swaps through it.",
                        },
                    ].map((item) => (
                        <div key={item.step} className="pool-card-3d p-4 flex flex-col gap-2 text-left">
                            <div className="w-7 h-7 rounded-lg flex items-center justify-center bg-usdx-accent/10 text-usdx-accent text-[12px] font-bold shrink-0">
                                {item.step}
                            </div>
                            <p className="text-[13px] font-bold text-usdx-ink">{item.title}</p>
                            <p className="text-[11px] text-usdx-ink-subtle leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>

                <h3 className="text-[12px] font-semibold text-usdx-ink-subtle uppercase tracking-widest mt-6 mb-4 text-left">
                    Things to know
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {[
                        {
                            title: "You must supply both sides",
                            desc: "Liquidity is always a pair. On an existing pool the second amount is fixed by the current ratio, so changing one side updates the other.",
                        },
                        {
                            title: "LP tokens are your receipt",
                            desc: "Your share of the pool is held as LP tokens. Keep them — they are what you redeem to withdraw the underlying pair.",
                        },
                        {
                            title: "Fees accrue in the pool",
                            desc: "The 0.30% taken on each swap stays in the pool, so your position grows in underlying tokens rather than paying out separately.",
                        },
                        {
                            title: "Divergent prices cost you",
                            desc: "If the two tokens move apart in price, withdrawing later can be worth less than simply holding them. This is impermanent loss.",
                        },
                    ].map((item) => (
                        <div key={item.title} className="pool-card-3d p-4 flex flex-col gap-1.5 text-left">
                            <p className="text-[12px] font-bold text-usdx-ink">{item.title}</p>
                            <p className="text-[11px] text-usdx-ink-subtle leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default AddLiquidity;
